module.exports = __webpack_public_path__ + "fonts/Inter-300-greek-ext38.2d64d8a.woff2";